var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBookBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6214 0L43.2429 12.5V37.5L21.6214 50L0 37.5V12.5L21.6214 0Z",
    className: "box"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.892 16.29C31.7543 16.1786 31.5933 16.0994 31.421 16.0584C31.2486 16.0173 31.0692 16.0154 30.8961 16.0528L21.6715 18.1278L12.4469 16.0291C12.271 15.9894 12.0883 15.9903 11.9128 16.0318C11.7373 16.0733 11.5735 16.1544 11.434 16.2687C11.2946 16.383 11.183 16.5277 11.1078 16.6916C11.0327 16.8556 10.9959 17.0345 11.0004 17.2148V31.6801C10.9937 31.9542 11.0822 32.2221 11.2508 32.4383C11.4194 32.6545 11.6577 32.8055 11.9252 32.8658L21.4106 35H21.9323L31.4177 32.8658C31.6852 32.8055 31.9235 32.6545 32.0922 32.4383C32.2608 32.2221 32.3493 31.9542 32.3426 31.6801V17.2148C32.3418 17.0367 32.3008 16.8611 32.2228 16.701C32.1448 16.5409 32.0318 16.4004 31.892 16.29ZM13.3717 18.6969L20.4858 20.2976V32.3322L13.3717 30.7316V18.6969ZM29.9712 30.7316L22.8571 32.3322V20.2976L29.9712 18.6969V30.7316Z",
    className: "symbol"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBookBox);
export default __webpack_public_path__ + "static/media/ico-book-box.e570b68b473b6008eab7629fc07875a8.svg";
export { ForwardRef as ReactComponent };